import React, { useEffect } from "react";
import { colors, font } from "../utils/theme.js";
import { ghostBtn } from "./ui.js";

// In-app confirmation for destructive actions. Cancel is focused by default and Esc cancels,
// so an accidental Enter/click never confirms. `tone` is "danger" (red) by default; pass
// tone="primary" for a confirmation that isn't destructive (e.g. "send this email").
export default function ConfirmDialog({ title, children, confirmLabel = "Delete", tone = "danger", onConfirm, onCancel }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);
  const confirmBg = tone === "primary" ? colors.accent : colors.danger;
  return (
    <div role="presentation" onClick={onCancel} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", zIndex: 1300, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(3px)" }}>
      <div role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" onClick={(e) => e.stopPropagation()}
        style={{ width: 420, maxWidth: "92vw", background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 22, boxShadow: "0 16px 40px rgba(0,0,0,0.5)" }}>
        <h3 id="confirm-title" style={{ margin: "0 0 10px", fontSize: 16, fontWeight: 700, color: colors.text }}>{title}</h3>
        <div style={{ fontSize: 13, color: colors.textMuted, lineHeight: 1.5 }}>{children}</div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
          <button autoFocus onClick={onCancel} style={ghostBtn}>Cancel</button>
          <button onClick={onConfirm} style={{ padding: "7px 14px", background: confirmBg, border: "none", borderRadius: 6, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: font }}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
